import React, { ComponentProps } from 'react'
import { Field } from 'react-final-form'

import { hasError as formHasError } from 'Services/Utils/form'

import PinInput from './PinInput'

type Props = ComponentProps<typeof PinInput> & {
  name: string
}

function PinInputField({ name, ...rest }: Props) {
  return (
    <Field name={name}>
      {({ input: { value, onChange }, meta }) => {
        const { error } = formHasError(meta)
        return (
          <PinInput {...rest} error={error} value={value} onChange={onChange} />
        )
      }}
    </Field>
  )
}

export default PinInputField
